import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminDashboardComponent } from './dashboard/admin-dashboard/admin-dashboard.component';
import { RoleManagementLandingComponent } from './pages/role-management/role-management-landing/role-management-landing.component';
import { SuperAgentManagementLandingComponent } from './pages/super-agent-management/super-agent-management-landing/super-agent-management-landing.component';
import { CreateSuperAgentComponents } from './pages/super-agent-management/create-super-agent/create-super-agent.component';
import {
  hasRoleGuard,
  RoutePermissionRestriction,
} from '../services/guard/has-role-guard/has-role.guard';
import { TicketGenerationLandingComponent } from './pages/ticketing/ticket-generation-landing/ticket-generation-landing.component';
import { AllTransactionHistoryComponent } from './pages/transactions/all-transaction-history/all-transaction-history.component';
import { ETicketListComponent } from './pages/ticketing/e-ticket-list/e-ticket-list.component';
import { TaxpayerLandingComponent } from './pages/taxpayer/taxpayer-landing/taxpayer-landing.component';
import { AdminManagementLandingComponent } from './pages/admin-management/admin-management-landing/admin-management-landing.component';
import { CreateAdminComponent } from './pages/admin-management/create-admin/create-admin.component';
import { IgrAssessmentAsinVerificationModalComponent } from './pages/igr-services/igr-assessment/igr-assessment-asin-verification-modal/igr-assessment-asin-verification-modal.component';
import { IgrAssessmentLandingComponent } from './pages/igr-services/igr-assessment/igr-assessment-landing/igr-assessment-landing.component';
import { WorkflowLandingComponent } from './pages/workflow/workflow-landing/workflow-landing.component';
import { LgaIdentificationLandingComponent } from './pages/non-igr-services/lga-identification/lga-identification-landing/lga-identification-landing.component';
import { LgaIdentificationApplicationComponent } from './pages/non-igr-services/lga-identification/lga-identification-application/lga-identification-application.component';
import { LgaSettingsComponent } from './pages/lga-settings/lga-settings/lga-settings.component';
import { VehicleTypeLandingComponent } from './pages/vehicle-type/vehicle-type-landing/vehicle-type-landing.component';
import { MotorParkLandingComponent } from './pages/motor-park/motor-park-landing/motor-park-landing.component';
import { StreetNamingLandingComponent } from './pages/non-igr-services/street-naming/street-naming-landing/street-naming-landing.component';
import { StreetNamingApplicationComponent } from './pages/non-igr-services/street-naming/street-naming-application/street-naming-application.component';
import { BirthRegistrationLandingComponent } from './pages/non-igr-services/birth-registration/birth-registration-landing/birth-registration-landing.component';
import { BirthRegistrationApplicationComponent } from './pages/non-igr-services/birth-registration/birth-registration-application/birth-registration-application.component';
import { MarriageRegistrationLandingComponent } from './pages/non-igr-services/marriage-registration/marriage-registration-landing/marriage-registration-landing.component';
import { MarriageRegistrationApplicationComponent } from './pages/non-igr-services/marriage-registration/marriage-registration-application/marriage-registration-application.component';
import { DeathRegistrationApplicationComponent } from './pages/non-igr-services/death-registration/death-registration-application/death-registration-application.component';
import { DeathRegistrationLandingComponent } from './pages/non-igr-services/death-registration/death-registration-landing/death-registration-landing.component';
import { SummaryDashboardComponent } from './dashboard/summary-dashboard/summary-dashboard.component';
import { AssetManagementDashboardComponent } from './asset-management/asset-management-dashboard/asset-management-dashboard.component';
import { TransportAssetLandingComponent } from './asset-management/modules/transport/transport-asset-landing/transport-asset-landing.component';
import { TransportAssetDetailsPageComponent } from './asset-management/modules/transport/transport-asset-details-page/transport-asset-details-page.component';
import { PropertyAssetDetailsPageComponent } from './asset-management/modules/property/property-asset-details-page/property-asset-details-page.component';
import { PropertyAssetLandingComponent } from './asset-management/modules/property/property-asset-landing/property-asset-landing.component';
import { MarketAssetLandingComponent } from './asset-management/modules/market/market-asset-landing/market-asset-landing.component';
import { MarketAssetDetailsPageComponent } from './asset-management/modules/market/market-asset-details-page/market-asset-details-page.component';
import { CollectionsLandingComponent } from './collections-landing/collections-landing.component';
import { CouponLandingComponent } from './pages/coupon/coupon-landing/coupon-landing.component';
import { ManualReconciliationComponent } from './pages/reconciliation/manual-reconciliation/manual-reconciliation.component';
import { TicketsSoldLandingComponent } from './pages/tickets-sold/tickets-sold-landing/tickets-sold-landing.component';
import { PerformanceReportDashboardComponent } from './dashboard/performance-report-dashboard/performance-report-dashboard.component';
import { AssessmentReportDashboardComponent } from './dashboard/assessment-report-dashboard/assessment-report-dashboard.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    pathMatch: 'full',
    component: AdminDashboardComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_DASHBOARD'],
        },
      ] as RoutePermissionRestriction[],
    },
  },

  {
    path: 'summary-dashboard',
    pathMatch: 'full',
    component: SummaryDashboardComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_DASHBOARD'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'performance-report-dashboard',
    pathMatch: 'full',
    component: PerformanceReportDashboardComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_DASHBOARD'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'assessment-report-dashboard',
    pathMatch: 'full',
    component: AssessmentReportDashboardComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_DASHBOARD'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'collections',
    pathMatch: 'full',
    component: CollectionsLandingComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_COLLECTIONS'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'asset-management',
    pathMatch: 'full',
    component: AssetManagementDashboardComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_ASSETS'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'asset-management/transport',
    pathMatch: 'full',
    component: TransportAssetLandingComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_ASSETS'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'asset-management/transport/details',
    pathMatch: 'full',
    component: TransportAssetDetailsPageComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_ASSETS'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'asset-management/property',
    pathMatch: 'full',
    component: PropertyAssetLandingComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_ASSETS'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'asset-management/property/details',
    pathMatch: 'full',
    component: PropertyAssetDetailsPageComponent    ,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_ASSETS'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'asset-management/market',
    pathMatch: 'full',
    component: MarketAssetLandingComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_ASSETS'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'asset-management/market/details',
    pathMatch: 'full',
    component: MarketAssetDetailsPageComponent    ,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_ASSETS'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'role-management',
    pathMatch: 'full',
    component: RoleManagementLandingComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['ROLE_MANAGEMENT', 'GENERAL_PERMISSION', 'LGA_HEAD'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'role-management',
    pathMatch: 'full',
    component: RoleManagementLandingComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['ROLE_MANAGEMENT', 'GENERAL_PERMISSION', 'LGA_HEAD'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'super-agent',
    pathMatch: 'full',
    component: SuperAgentManagementLandingComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['MANAGE_SUPER_AGENT', 'GENERAL_PERMISSION', 'LGA_HEAD'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'taxpayer',
    pathMatch: 'full',
    component: TaxpayerLandingComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['MANAGE_TAXPAYER', 'GENERAL_PERMISSION', 'LGA_HEAD'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'super-agent/create',
    pathMatch: 'full',
    component: CreateSuperAgentComponents,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['MANAGE_SUPER_AGENT', 'GENERAL_PERMISSION', 'LGA_HEAD'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'super-agent/view',
    pathMatch: 'full',
    component: CreateSuperAgentComponents,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['MANAGE_SUPER_AGENT', 'GENERAL_PERMISSION', 'LGA_HEAD'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'e-ticketing/ticket-generation-landing',
    pathMatch: 'full',
    component: TicketGenerationLandingComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['MANAGE_TICKETS', 'GENERAL_PERMISSION', 'LGA_HEAD'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'all-transaction-history',
    pathMatch: 'full',
    component: AllTransactionHistoryComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: [
            'MANAGE_TRANSACTIONS',
            'GENERAL_PERMISSION',
            'LGA_HEAD',
          ],
        },
      ] as RoutePermissionRestriction[],
    },
  },

  {
    path: 'batch/e-ticketing',
    pathMatch: 'full',
    component: ETicketListComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: [
            'MANAGE_TRANSACTIONS',
            'GENERAL_PERMISSION',
            'LGA_HEAD',
          ],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'admin-management',
    pathMatch: 'full',
    component: AdminManagementLandingComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'admin-management/create',
    pathMatch: 'full',
    component: CreateAdminComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'igr-assessment',
    pathMatch: 'full',
    component: IgrAssessmentLandingComponent,

  },

  {
    path: 'lga-identification',
    pathMatch: 'full',
    component: LgaIdentificationLandingComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'lga-identification/create',
    pathMatch: 'full',
    component: LgaIdentificationApplicationComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'marriage-registration',
    pathMatch: 'full',
    component: MarriageRegistrationLandingComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'marriage-registration/register',
    pathMatch: 'full',
    component: MarriageRegistrationApplicationComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'street-naming',
    pathMatch: 'full',
    component: StreetNamingLandingComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'street-naming/create',
    pathMatch: 'full',
    component: StreetNamingApplicationComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'birth-registration',
    pathMatch: 'full',
    component: BirthRegistrationLandingComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'birth-registration/apply',
    pathMatch: 'full',
    component: BirthRegistrationApplicationComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'vehicle-type',
    pathMatch: 'full',
    component: VehicleTypeLandingComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'motor-park',
    pathMatch: 'full',
    component: MotorParkLandingComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'workflow-settings',
    pathMatch: 'full',
    component: WorkflowLandingComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'lga-settings',
    pathMatch: 'full',
    component: LgaSettingsComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD'],
        },
      ],
    },
  },
  {
    path: 'death-registration',
    pathMatch: 'full',
    component: DeathRegistrationLandingComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'death-registration/apply',
    pathMatch: 'full',
    component: DeathRegistrationApplicationComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [{}] as RoutePermissionRestriction[],
    },
  },
  {
    path: 'coupons',
    pathMatch: 'full',
    component: CouponLandingComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: ['GENERAL_PERMISSION', 'CAN_MANAGE_TAXPAYER'],
    },
  },
  {
    path: 'manual-reconciliation',
    pathMatch: 'full',
    component: ManualReconciliationComponent,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_COLLECTIONS', 'CAN_VIEW_IGR_ASSESSMENT', 'CAN_MANAGE_TAXPAYER'],
        },
      ] as RoutePermissionRestriction[],
    },
  },

  {
    path: 'tickets-sold',
    pathMatch: 'full',
    component: TicketsSoldLandingComponent ,
    // canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: ['GENERAL_PERMISSION', 'LGA_HEAD', 'CAN_VIEW_COLLECTIONS', 'CAN_VIEW_IGR_ASSESSMENT'],
        },
      ] as RoutePermissionRestriction[],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
